
import ImageconverterModule from './ImageconverterModule';

export function convertImage(str): string {
  return ImageconverterModule.convertImage(str);
}

export function convertImageToAVIF(str): string {
  return ImageconverterModule.convertToAVIF(str);
}

export function convertImageToWEBP(str, quality:number = 90, lossless:boolean = false): string {
  return ImageconverterModule.convertToWEBP(str, quality, lossless);
}
export async function convertImageToWEBPAsync(str, quality:number = 90, lossless:boolean = false): Promise<string> {
  return await ImageconverterModule.convertToWEBPAsync(str, quality, lossless);
}

export function deleteFile(str): string {
  return ImageconverterModule.deleteFile(str);
}
